// 弹窗可缩放hook
import { ref, onMounted, onBeforeUnmount } from '@vue/composition-api';

export function useResizable(resizableDiv: any, initialWidth: number, initialHeight: number, isModalShow: any) {
  const width = ref(initialWidth);
  const height = ref(initialHeight);
  const isResizing = ref(false);
  const edge = ref<string | null>(null);

  const minWidth = 375;
  const minHeight = initialHeight * 0.8;

  const startResize = (event: MouseEvent) => {
    edge.value = getEdge(event);
    if (edge.value) {
      isResizing.value = true;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      event.stopPropagation();
      event.preventDefault();
      document.body.classList.add('no-select'); // 禁用文字选中
    }
  };

  const onMouseMove = (event: MouseEvent) => {
    if (isResizing.value) {
      const rect = resizableDiv.value.getBoundingClientRect();
      const maxWidth = window.innerWidth * 0.9;
      const maxHeight = window.innerHeight * 0.9;

      if (edge.value?.includes('right')) {
        const newWidth = event.clientX - rect.left;
        if (newWidth >= minWidth && newWidth <= maxWidth && event.clientX <= window.innerWidth) {
          width.value = newWidth;
        }
      }
      if (edge.value?.includes('bottom')) {
        const newHeight = event.clientY - rect.top;
        if (newHeight >= minHeight && newHeight <= maxHeight && event.clientY <= window.innerHeight) {
          height.value = newHeight;
        }
      }
      if (edge.value?.includes('left')) {
        const newWidth = rect.right - event.clientX;
        if (newWidth >= minWidth && newWidth <= maxWidth && event.clientX >= 0) {
          width.value = newWidth;
          resizableDiv.value.style.left = `${event.clientX}px`;
        }
      }
      if (edge.value?.includes('top')) {
        const newHeight = rect.bottom - event.clientY;
        if (newHeight >= minHeight && newHeight <= maxHeight && event.clientY >= 0) {
          height.value = newHeight;
          resizableDiv.value.style.top = `${event.clientY}px`;
        }
      }
    }
  };

  const onMouseUp = () => {
    isResizing.value = false;
    edge.value = null;
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    document.body.classList.remove('no-select'); // 恢复文字选中
  };

  const getEdge = (event: MouseEvent): string | null => {
    const rect = resizableDiv.value.getBoundingClientRect();
    const outerEdgeSize = 15; // 边框外的检测范围
    const innerEdgeSize = 5; // 边框内的检测范围
    const edges: string[] = [];

    if (event.clientX >= rect.right - outerEdgeSize && event.clientX <= rect.right + innerEdgeSize) {
      edges.push('right');
    }
    if (event.clientX >= rect.left - innerEdgeSize && event.clientX <= rect.left + outerEdgeSize) {
      edges.push('left');
    }
    if (event.clientY >= rect.bottom - outerEdgeSize && event.clientY <= rect.bottom + innerEdgeSize) {
      edges.push('bottom');
    }
    if (event.clientY >= rect.top - innerEdgeSize && event.clientY <= rect.top + outerEdgeSize) {
      edges.push('top');
    }

    return edges.join('-') || null;
  };

  onMounted(() => {
    resizableDiv.value.addEventListener('mousemove', (event: MouseEvent) => {
      if (isModalShow.value) {
        return;
      }
      const edge = getEdge(event);
      if (edge) {
        if (edge.includes('right') || edge.includes('left')) {
          resizableDiv.value.style.cursor = 'ew-resize';
        } else if (edge.includes('top') || edge.includes('bottom')) {
          resizableDiv.value.style.cursor = 'ns-resize';
        }
        if ((edge.includes('top') && edge.includes('left')) || (edge.includes('bottom') && edge.includes('right'))) {
          resizableDiv.value.style.cursor = 'nwse-resize';
        } else if (
          (edge.includes('top') && edge.includes('right'))
          || (edge.includes('bottom') && edge.includes('left'))
        ) {
          resizableDiv.value.style.cursor = 'nesw-resize';
        }
      } else {
        resizableDiv.value.style.cursor = 'default';
      }
    });
  });

  onBeforeUnmount(() => {
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  });

  return {
    width,
    height,
    startResize,
  };
}
